module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 

var group = function () {
	return groups.find(function (g) {
		return g['value'] === groupBy;
	}) || {};
};

var groupTitles = function () {
	return group()['groupTitle'];
};

var groupTitle = function (level) {
    return groupTitles()[level];
};
var subLength = function (arr) {
	var len = 0;
	arr.forEach(function (row) {
		len+=row.length;
	})
	return len;
}

var toHectare = function (value) {
    if (value == null || value === '') {
        return '';
    }

    return _.round(value / 10000, 2);
};

var numFormat = function (num) {
    if (num && num.length)
        num = num.replace('.',',');
    return num;
}

    ; __append("\n\n<div class=\"wh100\">\n	<style>\n		.width-regulator td:nth-child(-n+")
    ; __append(escapeFn(groupTitles().length))
    ; __append(") {\n			width : 11%;\n		}\n		.width-regulator td:nth-child(")
    ; __append(escapeFn(groupTitles().length+1))
    ; __append(") {\n			width : 4%;\n		}\n		.width-regulator thead td,\n		.width-regulator td:nth-child(1){\n			word-wrap:break-word;\n		} ")
    ; __append("\n	</style>\n\n\n\n	<table class=\"w100 gl-report__table width-regulator\">\n		<thead>\n			<tr>\n				")
    ;  for (var i=0; i<groupTitles().length; i++) {
    ; __append("\n					<td rowspan=\"2\">")
    ; __append(escapeFn( groupTitle(i) ))
    ; __append("</td>\n				")
    ;  } 
    ; __append("\n				<td rowspan=\"2\">Количество</td>\n				<td colspan=\"3\">Площадь, га</td>\n				<td rowspan=\"2\">Валовый сбор продукции, тн.</td>\n\n				<td rowspan=\"2\">Урожайность, ср. (ц/га)</td>\n\n				<td rowspan=\"2\">Содержание К, ср.</td>\n\n				<td rowspan=\"2\">Содержание N, ср.</td>\n\n				<td rowspan=\"2\">Содержание P, ср.</td>\n			</tr>\n			<tr>\n				<td>Док.</td>\n				<td>Факт.</td>\n				<td>+/-</td>\n			</tr>\n		</thead>\n	</table>\n\n")
    ;  var showDataCells = function (row, tag) {
	tag = tag || 'td';
    ; __append("\n\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append(escapeFn( row.fields_num ))
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append(escapeFn( numFormat(_.round(row.fields_area, 2).toString()) ))
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append(escapeFn( numFormat(toHectare(row.spatial_area).toString()) ))
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append(escapeFn( numFormat(_.round(row.diff, 2).toString()) ))
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append( row.valovoysborprodukcii !== undefined ? numFormat(_.round(row.valovoysborprodukcii, 1).toString()) : '&mdash;' )
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append( row.fields_harvest_avg !== undefined ? numFormat( _.round(row.fields_harvest_avg, 2).toString()) : '&mdash;' )
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append(escapeFn(numFormat( _.round(row.vneseno_k_avg, 2).toString()) ))
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append(escapeFn( numFormat( _.round(row.vneseno_n_avg, 2).toString()) ))
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n	<")
    ; __append(escapeFn(tag))
    ; __append(">")
    ; __append(escapeFn( numFormat( _.round(row.vneseno_p_avg, 2).toString()) ))
    ; __append("</")
    ; __append(escapeFn(tag))
    ; __append(">\n")
    ;  } 
    ; __append("\n\n\n\n\n    <div class=\"wh100\">\n        <div class=\"cell__abs_container\">\n            <div class=\"cell__abs overflow-y__auto\">\n                <table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n                    <tbody>\n\n					")
    ;  if (groupTitles().length == 3) { /* 3ух уровневые отчёты */ 
    ; __append("\n						")
    ;  data.rows.forEach(function (orgData) { 
    ; __append("\n							")
    ;  orgData.rows.forEach(function (row1, index1) { 
    ; __append("\n								")
    ;  row1.forEach(function (row2, index2) { 
    ; __append("\n									<tr>\n										")
    ;  if (!index2) { 
    ; __append("\n											")
    ;  if (!index1) { 
    ; __append("\n												<td rowspan=\"")
    ; __append(escapeFn( subLength(orgData.rows)+1 ))
    ; __append("\">")
    ; __append( row2.group_1_name )
    ; __append("</td>\n											")
    ;  } 
    ; __append("\n											<td rowspan=\"")
    ; __append(escapeFn( row1.length ))
    ; __append("\">")
    ; __append( row2.group_2_name )
    ; __append("</td>\n										")
    ;  } 
    ; __append("\n										<td>")
    ; __append( row2.group_3_name.replace(/,/ig, '<br>') )
    ; __append("</td>\n										")
    ;  showDataCells(row2) 
    ; __append("\n									</tr>\n								")
    ;  }) 
    ; __append("\n							")
    ;  }) 
    ; __append("\n							<tr>\n								<th colspan=\"2\">Итого</th>\n								")
    ;  showDataCells(orgData.total, 'th')
    ; __append("\n							</tr>\n						")
    ;  }) 
    ; __append("\n					")
    ;  } else if (groupTitles().length == 2) { /* 1ух уровневые отчёты */ 
    ; __append("\n						")
    ;  data.rows.forEach(function (row1, index1) { 
    ; __append("\n							")
    ;  row1.rows.forEach(function (row2, index2) { 
    ; __append("\n								<tr>\n									")
    ;  if (!index2) { 
    ; __append("\n										<td rowspan=\"")
    ; __append(escapeFn( row1.rows.length ))
    ; __append("\">")
    ; __append( row2.group_1_name )
    ; __append("</td>\n									")
    ;  } 
    ; __append("\n									<td>")
    ; __append( row2.group_2_name.replace(/,/ig, '<br>') )
    ; __append("</td>\n									")
    ;  showDataCells(row2) 
    ; __append("\n								</tr>\n							")
    ;  }) 
    ; __append("\n						")
    ;  }) 
    ; __append("\n					")
    ;  } else { 
    ; __append("\n						")
    ;  data.rows.forEach(function (row1) { 
    ; __append("\n							<tr>\n								<td>")
    ; __append( row1.group_1_name )
    ; __append("</td>\n								")
    ;  showDataCells(row1) 
    ; __append("\n							</tr>\n						")
    ;  }) 
    ; __append("\n					")
    ;  } 
    ; __append("\n\n                    <tr>\n                        <th colspan=\"")
    ; __append(escapeFn( groupTitles().length ))
    ; __append("\">Итого</th>\n						")
    ;  showDataCells(data.total, 'th')
    ; __append("\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n</div>\n")
  }
  return __output.join("");

}